import { ProductDeliveryTypeDeliveryTypeEnum } from '@generated-client/backend';
import { dayPluralForm } from '@trwl/util';

export const SITE_NAME = 'trwl';
export const SUPPORT_TG = 'https://t.me/trwl_help';
export const YM_ID = 98419341;
export const CURRENT_YEAR = new Date().getFullYear();
export const DISABLED_ORDERS_DATE = new Date('2025-03-6');
export const APP_STORE_LINK = 'https://apps.apple.com/app/id6740162965';
export const PLAY_MARKET_LINK =
  'https://play.google.com/store/apps/details?id=store.trwl.www.twa';

export const DELIVERY_DURATION: {
  [key in ProductDeliveryTypeDeliveryTypeEnum]: {
    min: number;
    max: number;
    country_delivery: number;
    toMoscow: number;
  };
} = {
  AIRPLANE: { min: 5, max: 9, country_delivery: 5, toMoscow: 2 },
  DEFAULT: { min: 17, max: 22, country_delivery: 18, toMoscow: 14 },
};

export const DELIVERY_TEXTS: {
  [key in ProductDeliveryTypeDeliveryTypeEnum]: (days: number) => string;
} = {
  AIRPLANE: (days: number) => {
    const totalDays = days + DELIVERY_DURATION.AIRPLANE.country_delivery;
    return `≈${totalDays} ${dayPluralForm(totalDays)}`;
  },
  DEFAULT: (days: number) => {
    const totalDays = days + DELIVERY_DURATION.DEFAULT.country_delivery;
    return `≈${totalDays} ${dayPluralForm(totalDays)}`;
  },
  /* NOTE
  AIRPLANE: (days: number) =>
      `${days + DELIVERY_DURATION.AIRPLANE.min}-${days + DELIVERY_DURATION.AIRPLANE.max} дней`,
  DEFAULT: (days: number) =>
      `${days + DELIVERY_DURATION.DEFAULT.min}-${days + DELIVERY_DURATION.DEFAULT.max} дней`,
   */
};

export const YANDEX_MAP_API_KEY = 'b9e48e45-92b5-4881-9076-85821adc2445';
